import React, { DetailedHTMLProps, FC } from 'react'
import KeepTruckinLogo from 'assets/logos/keeptruckin-logo.svg'
import Project44Logo from 'assets/logos/project44-logo.svg'
import { TIntegrationType } from 'apps/fleet-planner/types'

const LOGOS: Record<TIntegrationType, { src: string; alt: string }> = {
  keepTruckin: {
    src: KeepTruckinLogo,
    alt: 'KeepTruckin',
  },
  project44: {
    src: Project44Logo,
    alt: 'Project 44',
  },
}

interface IEldProviderLogoImageProps
  extends Omit<
    DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
    'src' | 'alt'
  > {
  /**
   * @example 'keepTruckin'
   */
  logoName: TIntegrationType
}

/**
 * Helper component which just requires a string prop to render one of the logos
 */
export const EldProviderLogoImage: FC<IEldProviderLogoImageProps> = ({ logoName, ...props }) => {
  const { alt, src } = LOGOS[logoName] || {}
  return <img src={src} alt={alt} {...props} />
}
